export default function Calendar({ fill, width, height }) {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 22 23"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.07502 1.6251C8.07502 1.12804 7.67208 0.725098 7.17502 0.725098C6.67797 0.725098 6.27502 1.12804 6.27502 1.6251V2.7002H5.19998C2.52139 2.7002 0.349976 4.87161 0.349976 7.5502V9.525V17.4252C0.349976 20.1038 2.52139 22.2752 5.19998 22.2752H17.05C19.7286 22.2752 21.9 20.1038 21.9 17.4252V9.525V7.5502C21.9 4.87161 19.7286 2.7002 17.05 2.7002H15.9749V1.6251C15.9749 1.12804 15.572 0.725098 15.0749 0.725098C14.5779 0.725098 14.1749 1.12804 14.1749 1.6251V2.7002H8.07502V1.6251ZM20.1 8.625V7.5502C20.1 5.86573 18.7344 4.5002 17.05 4.5002H15.9749V5.5751C15.9749 6.07215 15.572 6.4751 15.0749 6.4751C14.5779 6.4751 14.1749 6.07215 14.1749 5.5751V4.5002H8.07502V5.5751C8.07502 6.07215 7.67208 6.4751 7.17502 6.4751C6.67797 6.4751 6.27502 6.07215 6.27502 5.5751V4.5002H5.19998C3.51551 4.5002 2.14998 5.86573 2.14998 7.5502V8.625H20.1ZM2.14998 10.425H20.1V17.4252C20.1 19.1097 18.7344 20.4752 17.05 20.4752H5.19998C3.51551 20.4752 2.14998 19.1097 2.14998 17.4252V10.425Z"
        />
      </svg>
    )
  }
  